module.exports = __webpack_public_path__ + "images/appstore_cc05b07d337bb0e03d12666bf6292ac8.svg";